import React, { Component } from "react";
import {
  Paper,
  FlatButton,
  RaisedButton,
  DropDownMenu,
  MenuItem,
  Subheader,
  Divider,
  TextField,
} from "material-ui";
import Loading from "../Loading";
import templateEngine from "../../../utils/templateEngine";
import formatDate from "../../../utils/formatDate";

// WYSIWYG Editor
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from "react-draft-wysiwyg";
import {
  convertFromRaw,
  convertFromHTML,
  EditorState,
  ContentState,
} from "draft-js";

export default class PreviewClientNag extends Component {
  constructor(props) {
    super(props);
  }

  RenderPdfButton(template, client, i) {
    return (
      <Paper
        className="container"
        key={i}
        style={{ margin: "0.5em", padding: "0.5em", width: "25%" }}
      >
        <center>
          <p>{template.name}</p>
          <FlatButton
            label="Get Pdf"
            onTouchTap={this.requestPdf.bind(this, template._id, client._id)}
            style={{ marginRight: 12 }}
          />
        </center>
      </Paper>
    );
  }

  requestPdf(template, client) {
    window.open(
      `/api/unAuth/downloadPdf?template=${template}&client=${client}`,
    );
  }

  RenderDocButton(doc, client, i) {
    return (
      <Paper
        className="container"
        key={i}
        style={{ margin: "0.5em", padding: "0.5em", width: "25%" }}
      >
        <center>
          <p>{doc.name}</p>
          <FlatButton
            label="Get Document"
            onTouchTap={this.requestDoc.bind(this, doc.name, client._id)}
            style={{ marginRight: 12 }}
          />
        </center>
      </Paper>
    );
  }

  requestDoc(docType, client) {
    window.open(`/api/unAuth/downloadDoc?docType=${docType}&client=${client}`);
  }

  render() {
    let { template } = this.props;
    let client = this.props.client;
    client.date = formatDate(new Date());
    client.year = new Date().getFullYear();
    client.lastYear = new Date().getFullYear() - 1;
    let subject = template.subject
      ? templateEngine(template.subject, client)
      : "";
    let content = template.content
      ? templateEngine(template.content, client)
      : "";
    let blocksFromHtml = convertFromHTML(content);
    let contentState = ContentState.createFromBlockArray(blocksFromHtml);
    let editorState = EditorState.createWithContent(contentState);

    if (this.props.isLoading) {
      return (
        <div>
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return (
        <div>
          <TextField
            fullWidth
            readOnly
            floatingLabelText="Subject"
            value={subject}
          />
          <Editor editorState={editorState} ReadOnly toolbarHidden />
          {this.props.attachments.length > 0 && (
            <div>
              <Divider />
              <Subheader>Attachments</Subheader>
              {this.props.attachments.map((template, i) =>
                this.RenderPdfButton(template, client, i),
              )}
            </div>
          )}
          <br />
          {this.props.documents.length > 0 && (
            <div>
              <Divider />
              <Subheader>Documents</Subheader>
              {this.props.documents.map((doc, i) =>
                this.RenderDocButton(doc, client, i),
              )}
            </div>
          )}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/Email/PreviewClientNag.js